import { Card, Tag, Descriptions } from "antd";
import dayjs from "dayjs";
export default function BillCard({ bill, onClick }) {
  const billStatusMap = {
    unpaid: { color: "red", text: "未支付" },
    paid: { color: "green", text: "已支付" },
    partiallyPaid: { color: "orange", text: "部分支付" },
    cancelled: { color: "gray", text: "已取消" },
  }; //根据状态返回不同的颜色
  const {
    billType,
    waterMeterStart,
    waterMeterEnd,
    electricityMeterStart,
    electricityMeterEnd,
    startDate,
    endDate,
    dueDate,
    amount,
    status,
    billNames,
    notes,
    days,
    origindata,
  } = bill;
  // console.log("bill", bill);
  return (
    // <Card
    //   style={{ marginBottom: 6 }}
    //   size="small"
    //   hoverable
    //   title={`${billNames}. (${startDate} - ${endDate})`}
    //   onClick={onClick}
    //   extra={
    //     <>
    //       <span style={{ marginRight: 8, color: dueDate.color }}>
    //         {dueDate.text}
    //       </span>
    //       <Tag color={billStatusMap[status].color}>
    //         {/* {billStatusMap[status].text} */}
    //         {amount}
    //       </Tag>
    //     </>
    //   }
    // >
    //   <Descriptions column={6} size="small">
    //     {/* <Descriptions.Item label="账单名称">{billNames}</Descriptions.Item> */}
    //     <Descriptions.Item label="起始日期">{startDate}</Descriptions.Item>
    //     <Descriptions.Item label="结束日期">{endDate}</Descriptions.Item>
    //     {waterMeterStart ? (
    //       <Descriptions.Item label="水表起始">
    //         {waterMeterStart}
    //       </Descriptions.Item>
    //     ) : null}
    //     {waterMeterEnd ? (
    //       <Descriptions.Item label="水表最终">
    //         {waterMeterEnd}
    //       </Descriptions.Item>
    //     ) : null}
    //     {electricityMeterStart ? (
    //       <Descriptions.Item label="电表起始">
    //         {electricityMeterStart}
    //       </Descriptions.Item>
    //     ) : null}
    //     {electricityMeterEnd ? (
    //       <Descriptions.Item label="电表最终">
    //         {electricityMeterEnd}
    //       </Descriptions.Item>
    //     ) : null}
    //     {/* <Descriptions.Item label="金额">{amount}</Descriptions.Item> */}
    //   </Descriptions>
    // </Card>

    <Card
      // size="xs"
      bordered={false}
      bodyStyle={{ padding: 10, fontSize: 12 }}
      style={{
        borderRadius: 6,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
      }}
      title={`${billNames}`}
      onClick={onClick}
      extra={
        <>
          <span style={{ marginRight: 8, color: dueDate.color }}>
            {status !== "paid" && dueDate.text}
          </span>
          <Tag color={billStatusMap[status].color}>
            {/* {billStatusMap[status].text} */}
            {amount}
          </Tag>
        </>
      }
    >
      {/* 卡片内容：网格布局 */}
      <div style={{}}>
        <div>周期: {`${startDate} - ${endDate}（${days}天）`}</div>
        {/* <div>金额: ${bill.amount}</div> */}
        {billType === "waterElectricity" ? (
          <>
            <div>
              水表: {`${waterMeterStart ?? ""} - ${waterMeterEnd ?? ""}`}
            </div>
            <div>
              电表:{" "}
              {`${electricityMeterStart ?? ""} - ${electricityMeterEnd ?? ""}`}
            </div>
          </>
        ) : null}
        <div>备注: {notes}</div>
      </div>
    </Card>
  );
}
